import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { environment } from '../environments/environment';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database'
import { AngularFireStorageModule } from '@angular/fire/compat/storage'
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FindPartnersComponent } from './find-partners/find-partners.component';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { NewProjectComponent } from './new-project/new-project.component';
import { IntegerInputDirective } from './integer-input.directive';
import { ProjectCardComponent } from "./project-card/project-card.component";
import { ProjectDetailsComponent } from './project-details/project-details.component';
import { FeatureCardComponent } from './feature-card/feature-card.component';
import { FindProjectsComponent } from './find-projects/find-projects.component';
import { PartnerCardComponent } from './partner-card/partner-card.component';
import { ContactUsComponent } from './contact-us/contact-us.component';
import { WhoWeAreComponent } from './who-we-are/who-we-are.component.';
import { RecyclingBinComponent } from './recycling-bin/recycling-bin.component';
import { ProjectFormComponent } from './project-form/project-form.component';
import { DraftsComponent } from './drafts/drafts.component';
import {ProjectFormNavComponent} from "./project-form/project-form-nav/project-form-nav.component";

@NgModule({
  declarations: [
    AppComponent,
    FindPartnersComponent,
    NewProjectComponent,
    IntegerInputDirective,
    ProjectDetailsComponent,
    FeatureCardComponent,
    FindProjectsComponent,
    PartnerCardComponent,
    ContactUsComponent,
    WhoWeAreComponent,
    RecyclingBinComponent,
    ProjectFormComponent,
    DraftsComponent,
  ],
    imports: [
        AngularFireModule.initializeApp(environment.firebase),
        AngularFireDatabaseModule,
        AngularFireStorageModule,
        BrowserModule,
        FormsModule,
        AppRoutingModule,
        provideFirebaseApp(() => initializeApp(environment.firebase)),
        provideFirestore(() => getFirestore()),
        ProjectCardComponent,
        ProjectFormNavComponent
    ],
  providers: [AngularFireModule, ],
  bootstrap: [AppComponent]
})
export class AppModule {}
